/** @type {import('tailwindcss').Config} */

module.exports = {
  // This option will append all the utility classes with the !important keyword to prevent overriding tailwind rules.
  important: true,
  prefix: 'tw-',
  content: ['./index.html', './src/**/*.{vue,js,ts,jsx,tsx}'],
  theme: {
    extend: {
      fontSize: {
        '3xs': ['0.5rem', '1.375'], // 8px 11px
        '2xs': ['0.625rem', '1.4'] // 10px 14px
      },
      colors: {
        black: '#000033',
        darkblue: '#000E55',
        whitesmoke: 'rgba(255, 255, 255, 0.8)',
      },
      screens: {
        'mobile': {'min': '320px', 'max': '480px'},
        "xs": "320px",
        "xs-max": "639px",
        "sm": "640px",
        "sm-max": "767px",
        "md": "768px",
        "md-max": "1023px",
        "md-max-scr": { "max": "1023px"},
        "lg": "1024px",
        "xl": "1280px",
        '2xl': '1440px',
      },
      transitionProperty: {
        'top': 'top',
      },
      minWidth: {
        '23': '5.75rem',
      },
      maxWidth: {
        '70': '70rem',
        '48r': '48rem',
        '56r': '56rem',
        '63.5r': '63.5rem',
        '70.75r': '70.75rem'
      },
      width: {
        '11r': '11rem',
        '10.75r': '10.75rem'
      },
      height: {
        '75px': '4.688rem',
        '67px': '4.188rem'
      },
      margin: {
        '1.25': '0.313rem',
      },
      padding: {
        '34': '8.25rem'
      }
    }
  },
  safelist: [
    'text-3xs',
    'text-2xs',
    'text-xs',
    'text-sm',
    'text-base',
    'text-lg',
    'text-xl',
    'grid',
    'sm:grid',
    'md:grid',
    'lg:grid',
    'xl:grid',
    '2xl:grid',
    'max-w-none',
    'bg-cover',
    'bg-center',
    'bg-no-repeat',
    'sm:container',
    'md:container',
    'lg:container',
    'xl:container',
    '2xl:container',
    'mx-auto',
    'grid-cols-2',
    'grid-cols-12',
    'col-span-2',
    'col-span-3',
    'col-span-4',
    'col-span-5',
    'col-span-6',
    'col-span-7',
    'col-span-8',
    'col-span-9',
    'col-span-10',
    'col-span-11',
    'col-span-12',
    'sm:col-span-2',
    'sm:col-span-3',
    'sm:col-span-4',
    'sm:col-span-5',
    'sm:col-span-6',
    'sm:col-span-7',
    'sm:col-span-8',
    'sm:col-span-9',
    'sm:col-span-10',
    'sm:col-span-11',
    'sm:col-span-12',
    'md:col-span-2',
    'md:col-span-3',
    'md:col-span-4',
    'md:col-span-5',
    'md:col-span-6',
    'md:col-span-7',
    'md:col-span-8',
    'md:col-span-9',
    'md:col-span-10',
    'md:col-span-11',
    'md:col-span-12',
    'lg:col-span-2',
    'lg:col-span-3',
    'lg:col-span-4',
    'lg:col-span-5',
    'lg:col-span-6',
    'lg:col-span-7',
    'lg:col-span-8',
    'lg:col-span-9',
    'lg:col-span-10',
    'lg:col-span-11',
    'lg:col-span-12',
    'xl:col-span-2',
    'xl:col-span-3',
    'xl:col-span-4',
    'xl:col-span-5',
    'xl:col-span-6',
    'xl:col-span-7',
    'xl:col-span-8',
    'xl:col-span-9',
    'xl:col-span-10',
    'xl:col-span-11',
    'xl:col-span-12',
    'px-2',
    'px-4',
    'px-6',
    'px-8',
    'py-12',
    'gap-2',
    'gap-4',
    'gap-6',
    'gap-8',
    'absolute',
    'relative',
    'z-10',
    'w-full',
    'h-full',
    'object-cover',
    'left-0',
    'top-0',
    'hidden',
    'sm:block',
    'md:block',
    'lg:block',
    'xl:block',
    'sm:hidden',
    'md:hidden',
    'lg:hidden',
    'xl:hidden',
    'tw-text-xs',
    'tw-text-sm',
    'tw-text-base',
    'tw-text-lg',
    'tw-text-xl',
    'tw-grid',
    'sm:tw-grid',
    'md:tw-grid',
    'lg:tw-grid',
    'xl:tw-grid',
    '2xl:tw-grid',
    'tw-max-w-none',
    'tw-bg-cover',
    'tw-bg-center',
    'tw-bg-no-repeat',
    'sm:tw-container',
    'md:tw-container',
    'lg:tw-container',
    'xl:tw-container',
    '2xl:tw-container',
    'tw-mx-auto',
    'tw-grid-cols-2',
    'tw-grid-cols-12',
    'tw-col-span-2',
    'tw-col-span-3',
    'tw-col-span-4',
    'tw-col-span-5',
    'tw-col-span-6',
    'tw-col-span-7',
    'tw-col-span-8',
    'tw-col-span-9',
    'tw-col-span-10',
    'tw-col-span-11',
    'tw-col-span-12',
    'sm:tw-col-span-2',
    'sm:tw-col-span-3',
    'sm:tw-col-span-4',
    'sm:tw-col-span-5',
    'sm:tw-col-span-6',
    'sm:tw-col-span-7',
    'sm:tw-col-span-8',
    'sm:tw-col-span-9',
    'sm:tw-col-span-10',
    'sm:tw-col-span-11',
    'sm:tw-col-span-12',
    'md:tw-col-span-2',
    'md:tw-col-span-3',
    'md:tw-col-span-4',
    'md:tw-col-span-5',
    'md:tw-col-span-6',
    'md:tw-col-span-7',
    'md:tw-col-span-8',
    'md:tw-col-span-9',
    'md:tw-col-span-10',
    'md:tw-col-span-11',
    'md:tw-col-span-12',
    'lg:tw-col-span-2',
    'lg:tw-col-span-3',
    'lg:tw-col-span-4',
    'lg:tw-col-span-5',
    'lg:tw-col-span-6',
    'lg:tw-col-span-7',
    'lg:tw-col-span-8',
    'lg:tw-col-span-9',
    'lg:tw-col-span-10',
    'lg:tw-col-span-11',
    'lg:tw-col-span-12',
    'xl:tw-col-span-2',
    'xl:tw-col-span-3',
    'xl:tw-col-span-4',
    'xl:tw-col-span-5',
    'xl:tw-col-span-6',
    'xl:tw-col-span-7',
    'xl:tw-col-span-8',
    'xl:tw-col-span-9',
    'xl:tw-col-span-10',
    'xl:tw-col-span-11',
    'xl:tw-col-span-12',
    'tw-px-2',
    'tw-px-4',
    'tw-px-6',
    'tw-px-8',
    'tw-py-12',
    'tw-gap-2',
    'tw-gap-4',
    'tw-gap-6',
    'tw-gap-8',
    'tw-absolute',
    'tw-relative',
    'tw-z-10',
    'tw-w-full',
    'tw-h-full',
    'tw-object-cover',
    'tw-left-0',
    'tw-top-0',
    'tw-hidden',
    'sm:tw-block',
    'md:tw-block',
    'lg:tw-block',
    'xl:tw-block',
    'sm:tw-hidden',
    'md:tw-hidden',
    'lg:tw-hidden',
    'xl:tw-hidden',
    'tw-overflow-hidden',
    'tw-fixed',
  ],
  plugins: [require('@tailwindcss/line-clamp')],
}
